import {logger} from './logger'
import {Util} from './util'

const cache = {
  xlsx: undefined as any
}

export function loadXLSX(cb: (xlsx: any) => void): void {
  if (cache.xlsx) {
    cb(cache.xlsx)
    return
  }
  const s = document.createElement('script')
  const wnd = window as any
  // const nodeRequire = wnd.require
  // const nodeModule = wnd.module
  delete wnd.require
  delete wnd.module

  s.src = '/js/lib/xlsx.core.min.js'
  s.onload = () => {
    logger.warn('xlsx lib loaded')
    cache.xlsx = (window as any).XLSX
    // wnd.require = nodeRequire
    // wnd.module = nodeModule
    cb(cache.xlsx)
  }
  document.body.appendChild(s)
}

function dateNum(v: string, date1904?: boolean): any {
  if (date1904) {
    v += 1462
  }
  const epoch = Date.parse(v)
  const dayMs = 24 * 3600 * 1000
  return (epoch - new Date(Date.UTC(1899, 11, 30)).getTime()) / dayMs
}

function sheetFromArray(xlsx: any, data: any[][], options: SaveOptions): any {
  const ws: any = {}
  const range: any = {
    s: {
      c: 10000000,
      r: 10000000
    },
    e: {
      c: 0,
      r: 0
    }
  }
  for (let R = 0; R !== data.length; ++R) {
    for (let C = 0; C !== data[R].length; ++C) {
      if (range.s.r > R) {
        range.s.r = R
      }
      if (range.s.c > C) {
        range.s.c = C
      }
      if (range.e.r < R) {
        range.e.r = R
      }
      if (range.e.c < C) {
        range.e.c = C
      }
      const cell: any = {v: Util.truncateString(data[R][C])}
      if (cell.v === null) {
        continue
      }
      const cellRef = xlsx.utils.encode_cell({c: C, r: R})

      if (typeof cell.v === 'number') {
        cell.t = 'n'
      } else if (typeof cell.v === 'boolean') {
        cell.t = 'b'
      } else if (cell.v instanceof Date) {
        cell.t = 'n'
        cell.z = xlsx.SSF._table[14]
        cell.v = dateNum(cell.v)
      } else {
        cell.t = 's'
      }
      ws[cellRef] = cell
    }
  }
  if (range.s.c < 10000000) {
    ws['!ref'] = xlsx.utils.encode_range(range)
  }

  if (data.length > 0) {
    if (options.columnsWidthToHead) {
      ws['!cols'] = fitHeadToColumn(data)
    } else if (options.columnsWidthToItems) {
      ws['!cols'] = fitItemsToColumn(data)
    }
  }

  return ws
}

function fitHeadToColumn(data: any[][]): {wch: number}[] {
  return data[0].map(headCell => ({
    wch: headCell ? headCell.toString().length : 0
  }))
}

function fitItemsToColumn(data: any[][]): {wch: number}[] {
  // get maximum character of each column
  return (
    data[0]?.map((_, cellId) => ({
      wch: Math.max(
        ...data.map(row => (row[cellId] ? row[cellId].toString().length : 0))
      )
    })) || []
  )
}

class Workbook {
  public SheetNames: any[] = []
  public Sheets: any = {}
}

function s2ab(s: string): ArrayBuffer {
  const buf = new ArrayBuffer(s.length)
  const view = new Uint8Array(buf)
  for (let i = 0; i !== s.length; ++i) {
    view[i] = s.charCodeAt(i) & 0xff
  }
  return buf
}

type SaveOptions = {
  columnsWidthToHead?: boolean
  columnsWidthToItems?: boolean
}

export function saveAsXlsx(
  filename: string,
  data: any[][],
  options: SaveOptions = {}
): void {
  loadXLSX((xlsx: any) => {
    const wb = new Workbook()
    const ws = sheetFromArray(xlsx, data, options)
    /* add worksheet to workbook */
    const sheetName = 'Sheet 1'
    wb.SheetNames.push(sheetName)
    wb.Sheets[sheetName] = ws
    const wbOut = xlsx.write(wb, {
      bookType: 'xlsx',
      bookSST: true,
      type: 'binary'
    })
    ;(window as any).saveAs(
      new Blob([s2ab(wbOut)], {type: 'application/octet-stream'}),
      filename
    )
  })
}
